import React, { useState } from "react";
import PropTypes from "prop-types";

import styled from "styled-components";

import ShareLinkTray from "../../molecules/ShareLinkTray";
import iconShare from "../../../assets/images/icons/share.svg";

const ShareButton = styled.a`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url("${iconShare}");
  &:not(:first-child) {
    margin-left: 20px;
  }
`;

const ShareLinkButton = ({
  isInBoxAndCartTray = false,
  urlLink,
  shareButtonClickTrack = () => {},
  copyLinkClickTrack = () => {},
}) => {
  const [isShareLinkTrayOpen, setShareLinkTrayDisplay] = useState(false);

  const handleShareClick = () => {
    shareButtonClickTrack();
    setShareLinkTrayDisplay(true);
  };

  if (isShareLinkTrayOpen) {
    return (
      <ShareLinkTray
        onShareLinkTrayClose={() => setShareLinkTrayDisplay(false)}
        isInBoxAndCartTray={isInBoxAndCartTray}
        urlLink={urlLink}
        copyLinkClickTrack={copyLinkClickTrack}
      />
    );
  }

  return <ShareButton onClick={handleShareClick} />;
};

ShareLinkButton.propTypes = {
  isInBoxAndCartTray: PropTypes.bool,
  urlLink: PropTypes.string.isRequired,
  shareButtonClickTrack: PropTypes.func,
  copyLinkClickTrack: PropTypes.func,
};

export default ShareLinkButton;
